<template>
  <div class="article-dialog" @contextmenu.stop>
    <el-dialog top="calc( 50vh - 150px )" custom-class="book-article" center :visible.sync="dialogVisible" :close-on-click-modal="true" :append-to-body="true" :handleCancel="handleCancel">
      <div class="article-dialog-container">
        <div class="content-title">
          <p>{{ articleItem.title }}</p>
        </div>
        <div class="full-content">{{ content }}</div>
        <div class="content">
          <div class="content-item">报纸名称：{{ articleItem.baoZhiName }}</div>
          <div class="content-item">数字报名称：{{ articleItem.epaperName }}</div>
          <div class="content-item">报纸刊期：{{ articleItem.periodical }}</div>
          <div class="content-item">版次：{{ articleItem.edition }}</div>
        </div>
        <div class="button-wrapper">
          <div class="button" @click="handleClick('article')">查看文章</div>
          <div class="button" @click="handleClick('epaper')">查看当期报纸</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'articleDialog',
  data() {
    return {
      dialogVisible: false,
      typeName: '书刊',
      qrDownload: false
    }
  },
  props: {
    articleItem: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    content() {
      console.log(this.articleItem)
      if (this.articleItem.content) {
        return this.articleItem.content.replace(/<[^<>]+>/g, '').replace(/&nbsp;/gi, '')
      }
      return ''
    }
  },

  methods: {
    handleCancel() {
      this.dialogVisible = false
    },
    handleClick(val) {
      this.$emit('handleClick', val)
    }
  },
  mounted() {}
}
</script>
<style lang="scss">
.article-dialog {
  .el-dialog__body {
    padding: 0 !important;
  }
}
.article-dialog-container {
  margin: 0 auto;
  .content-title {
    background-color: #d33636;
    width: 100%;
    font-size: 16px;
    color: #fff;
    text-align: center;
    overflow-x: hidden;
    overflow-y: scroll;
    margin-bottom: 10px;
    vertical-align: middle;
    padding: 0 10px;
  }
  .full-content {
    overflow: hidden;
    -webkit-line-clamp: 4;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    text-overflow: ellipsis;
    color: #7f7f7f;
    font-size: 12px;
    margin-bottom: 10px;
    line-height: 16px;
  }
  .content {
    padding: 20px 0;
    border-bottom: #cecece solid 1px;
    border-top: #cecece solid 1px;
  }
  .button-wrapper {
    display: flex;
    justify-content: space-evenly;
    margin-top: 20px;
    .button {
      height: 27px;
      line-height: 27px;
      background-color: #df5813;
      color: #ffffff;
      font-size: 12px;
      cursor: pointer;
      text-align: center;
      padding: 0 20px;
      border-radius: 5px;
    }
  }
}
.el-dialog {
  &.book-article {
    min-height: 300px;
    width: 90%;
    background-color: #e5e5e5;
    border-radius: 10px;
    .el-dialog__header {
      border-radius: 10px;
      background-color: #e5e5e5;
      .el-dialog__headerbtn {
        right: 10px;
      }
      .el-icon-close {
        color: #606266;
        font-size: 24px;
      }
    }
    .el-dialog__body {
      padding-top: 2px;
    }
    .article-content {
      margin-top: 0 !important;
    }
    .info {
      font-size: 12px !important;
    }
  }
}
</style>
